(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5022],{

/***/ 96201:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calculators/fuel-cost-calculator",
      function () {
        return __webpack_require__(37978);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 56130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CalculatorBlogs_Blog; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__(8193);
;// CONCATENATED MODULE: ./components/CalculatorBlogs/BlogCard.jsx




const BlogCard = (param)=>{
    let { question , answer  } = param;
    const [blogVisible, setBlogVisible] = (0,react.useState)(true);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex mb-[30px] pb-[30px] gap-[20px] border-b border-b-gray-300",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: ()=>blogVisible ? setBlogVisible(false) : setBlogVisible(true),
                className: "pt-[5px] text-[20px] md:text-[35px] w-fit cursor-pointer",
                children: blogVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineMinus */.ywL, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlinePlus */.Lfi, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "question text-[25px] md:text-[30px] mb-[20px] font-medium",
                        children: question
                    }),
                    blogVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "answer text-[16px] md:text-[18px] font-light text-gray-700",
                        children: answer
                    }) : ""
                ]
            })
        ]
    });
};
/* harmony default export */ var CalculatorBlogs_BlogCard = (BlogCard);

;// CONCATENATED MODULE: ./components/CalculatorBlogs/Blog.jsx



const Blog = (param)=>{
    let { heading , BlogData , width ="lg:w-[850px]"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-[100%] mx-auto md:w-[80%] ".concat(width),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "text-[25px] md:text-[40px] text-center font-bold mb-14 mx-auto",
                children: heading
            }),
            BlogData.map((blog)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CalculatorBlogs_BlogCard, {
                    question: blog.question,
                    answer: blog.answer
                }, blog.id);
            })
        ]
    });
};
/* harmony default export */ var CalculatorBlogs_Blog = (Blog);


/***/ }),

/***/ 37978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ fuel_cost_calculator; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/Tools/FuelCostCalc.jsx


const FuelCostCalc = ()=>{
    const [inputData, setInputData] = (0,react.useState)({
        distance: "500",
        distanceType: "kilometres",
        fuelEfficiency: "10",
        fuelEfficiencyType: "kilometresPerLitre",
        fuelCost: "3",
        fuelType: "perLitre"
    });
    const [resultData, setResultData] = (0,react.useState)({
        totalFuelCost: "150",
        distance: "500",
        requiredFuel: "50"
    });
    const calculateFuelCostAndQuantity = (0,react.useCallback)(()=>{
        let distanceMultiplier = 1;
        let fuelEfficiencyMultiplier = 1;
        let fuelPriceMultiplier = 1;
        let fuelRequired = 0;
        switch(inputData.distanceType){
            case "kilometres":
                distanceMultiplier = 1;
                break;
            case "miles":
                distanceMultiplier = 1.609344;
                break;
            default:
                break;
        }
        switch(inputData.fuelEfficiencyType){
            case "kilometresPerLitre":
                fuelEfficiencyMultiplier = 1;
                fuelRequired = inputData.distance * distanceMultiplier / inputData.fuelEfficiency;
                break;
            case "litresPer100km":
                fuelEfficiencyMultiplier = inputData.fuelEfficiency / 100;
                fuelRequired = inputData.distance * distanceMultiplier * fuelEfficiencyMultiplier;
                break;
            // case 'litresPerMile':
            //    fuelEfficiencyMultiplier = 0.264172052 * distanceMultiplier;
            //    fuelRequired = (inputData.distance * distanceMultiplier) / (fuelEfficiencyMultiplier * inputData.fuelEfficiency)
            //    break;
            case "milesPerGallon":
                fuelEfficiencyMultiplier = 0.425143707;
                fuelRequired = inputData.distance * distanceMultiplier / (fuelEfficiencyMultiplier * inputData.fuelEfficiency);
                break;
            default:
                break;
        }
        switch(inputData.fuelPriceType){
            case "perLitre":
                fuelPriceMultiplier = 1;
                break;
            case "perGallon":
                fuelPriceMultiplier = 3.78541178;
                break;
            default:
                break;
        }
        // const fuelRequired = (inputData.distance * distanceMultiplier) / (fuelEfficiencyMultiplier * inputData.fuelEfficiency);
        // setTotalFuelRequired(fuelRequired);
        // console.log(fuelRequired)
        const fuelCost = fuelRequired * inputData.fuelCost * fuelPriceMultiplier;
        // setTotalFuelCost(fuelCost);
        // console.log(fuelPriceMultiplier)
        // console.log(fuelRequired, " ", fuelCost)
        setResultData((prev)=>({
                ...prev,
                distance: inputData.distance,
                requiredFuel: fuelRequired,
                totalFuelCost: fuelCost
            }));
    }, [
        inputData
    ]);
    (0,react.useEffect)(()=>{
        calculateFuelCostAndQuantity();
    }, [
        calculateFuelCostAndQuantity
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full max-w-[1000px] bg-gray-100 mx-auto py-[30px] md:px-[30px] rounded-sm drop-shadow-lg flex flex-col lg:flex-row gap-[20px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "max-w-[100%] lg:w-[50%] h-full bg-white p-[10px] md:p-[20px] py-[30px] md:py-[30px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-col",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-gray-500 flex flex-col gap-[10px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "text-gray-700 font-medium text-[18px] border-b-2 pb-[15px] mb-[10px]",
                                children: "Fuel Cost By Distance Travelled"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex gap-[5px] flex-col justify-between items-start",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "text-gray-500 font-medium text-[16px]",
                                        children: "Trip Distance"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col md:flex-row items-start justify-center gap-[10px]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                className: "rounded-md border text-gray-500 outline-none py-2 px-3 w-full md:w-[50%] h-[50px]",
                                                id: "",
                                                name: "",
                                                type: "text",
                                                placeholder: "",
                                                required: true,
                                                value: inputData.distance,
                                                onChange: (e)=>setInputData((prev)=>({
                                                            ...prev,
                                                            distance: e.target.value
                                                        }))
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                className: "border outline-none rounded-md w-full md:w-[50%] h-[50px]",
                                                id: "",
                                                name: "",
                                                required: true,
                                                value: inputData.distanceType,
                                                onChange: (e)=>setInputData((prev)=>({
                                                            ...prev,
                                                            distanceType: e.target.value
                                                        })),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: "kilometres",
                                                        children: "kilometres"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: "miles",
                                                        children: "miles"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex gap-[5px] flex-col justify-between items-start",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "text-gray-500 font-medium text-[16px]",
                                        children: "Fuel Efficiency"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col md:flex-row items-start justify-center gap-[10px]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                className: "rounded-md border text-gray-500 outline-none py-2 px-3 w-full md:w-[50%] h-[50px]",
                                                id: "",
                                                name: "",
                                                type: "text",
                                                placeholder: "",
                                                required: true,
                                                value: inputData.fuelEfficiency,
                                                onChange: (e)=>setInputData((prev)=>({
                                                            ...prev,
                                                            fuelEfficiency: e.target.value
                                                        }))
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                className: "border outline-none rounded-md w-full md:w-[50%] h-[50px]",
                                                id: "",
                                                name: "",
                                                required: true,
                                                value: inputData.fuelEfficiencyType,
                                                onChange: (e)=>setInputData((prev)=>({
                                                            ...prev,
                                                            fuelEfficiencyType: e.target.value
                                                        })),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: "kilometresPerLitre",
                                                        children: "kilometers per liter (km/L)"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: "milesPerGallon",
                                                        children: "miles per gallon (mpg)"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: "litresPer100km",
                                                        children: "liters per 100km (L/100 km)"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex gap-[5px] flex-col justify-between items-start",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "text-gray-500 font-medium text-[16px]",
                                        children: "Gas/Fuel Price"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col md:flex-row items-start justify-center gap-[10px]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                className: "rounded-md border text-gray-500 outline-none py-2 px-3 w-full md:w-[50%] h-[50px]",
                                                id: "",
                                                name: "",
                                                type: "text",
                                                placeholder: "",
                                                required: true,
                                                value: inputData.fuelCost,
                                                onChange: (e)=>setInputData((prev)=>({
                                                            ...prev,
                                                            fuelCost: e.target.value
                                                        }))
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                className: "border outline-none rounded-md w-full md:w-[50%] h-[50px]",
                                                id: "",
                                                name: "",
                                                required: true,
                                                value: inputData.fuelType,
                                                onChange: (e)=>setInputData((prev)=>({
                                                            ...prev,
                                                            fuelType: e.target.value
                                                        })),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: "perLitre",
                                                        children: "per liter"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: "perGallon",
                                                        children: "per gallon"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: ()=>calculateFuelCostAndQuantity(),
                                className: "w-full h-[50px] mt-[20px] bg-violet-500 hover:opacity-75 text-white font-medium text-[18px] rounded-lg shadow-2xl",
                                children: "Calculate"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-[100%] lg:w-[50%] h-full flex flex-col gap-[20px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "text-white py-[2px] mb-[10px] h-[50px] flex items-center text-center justify-center px-[10px] font-medium text-[25px] bg-violet-500",
                        children: "Result"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col justify-center items-center bg-gray-200 w-fit mx-auto p-[30px] rounded-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "text-[20px] font-medium text-gray-500",
                                children: "Total Fuel Cost"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-[60px] font-bold text-gray-700",
                                children: [
                                    "$",
                                    parseFloat(resultData.totalFuelCost).toFixed(2)
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full text-gray-500 font-medium flex flex-col gap-[10px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: " flex items-center gap-[30px] justify-around text-[20px] mx-[15px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-[50%] text-center border-b-[1px] border-b-gray-400 pb-[5px] px-[5px]",
                                        children: "Units"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-[50%] text-center border-b-[1px] border-b-gray-400 pb-[5px] px-[5px]",
                                        children: "Output"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: " flex items-center justify-around text-[18px] text-gray-400",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-[50%] text-center",
                                        children: "Distance"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-[50%] text-center",
                                        children: inputData.distanceType === "kilometres" ? resultData.distance + " Km" : resultData.distance + " miles"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: " flex items-center justify-around text-[18px] text-gray-400",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-[50%] text-center",
                                        children: "Fuels Required"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-[50%] text-center",
                                        children: inputData.fuelType === "perLitre" ? parseFloat(resultData.requiredFuel).toFixed(2) + " Litres" : parseFloat(resultData.requiredFuel).toFixed(2) + " Gallons"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Tools_FuelCostCalc = (FuelCostCalc);

// EXTERNAL MODULE: ./components/CalculatorBlogs/Blog.jsx + 1 modules
var Blog = __webpack_require__(56130);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./pages/calculators/fuel-cost-calculator/index.jsx





const BlogData = [
    {
        id: 1,
        question: "How does the Fuel Cost Calculator work?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Our Fuel Cost Calculator uses fuel prices and distance travelled to calculate the total cost of fuel required for your trip. You simply input the distance you plan to travel and the current price of fuel, and the calculator will provide you with the total cost of fuel required for your trip."
            })
        })
    },
    {
        id: 2,
        question: "What are the benefits of using the Fuel Cost Calculator?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Using our Fuel Cost Calculator can help you plan your fuel expenses and stay within your budget. It can also help you compare fuel prices and find the cheapest fuel options for your trip."
            })
        })
    },
    {
        id: 3,
        question: "Can I save my calculations for future reference?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Yes, our Fuel Cost Calculator allows you to save your calculations for future reference. This feature is especially helpful if you frequently travel the same route and want to keep track of your fuel expenses."
            })
        })
    },
    {
        id: 4,
        question: "How does the calculator calculate the cost of fuel per gallon/litre?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Our Fuel Cost Calculator takes the total cost of fuel and divides it by the total volume of fuel required, which gives you the cost per gallon/litre of fuel."
            })
        })
    },
    {
        id: 5,
        question: "Can the Fuel Cost Calculator be used for different types of vehicles?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Yes, our Fuel Cost Calculator can be used for any type of vehicle as long as you know the distance you plan to travel and the current price of fuel."
            })
        })
    },
    {
        id: 6,
        question: "How accurate is the Fuel Cost Calculator?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Our Fuel Cost Calculator provides accurate estimates based on the distance traveled and the current price of fuel. However, the actual fuel cost may vary depending on factors such as traffic conditions, driving habits, and vehicle efficiency."
            })
        })
    },
    {
        id: 7,
        question: "Is the Fuel Cost Calculator free to use?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Yes, our Fuel Cost Calculator is completely free to use. Try it today and start saving money on your fuel costs!"
            })
        })
    }
];
const FuelCostCalculator = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "container mx-auto w-full px-[10px] lg:px-[100px] py-[20px] sm:py-[100px] flex flex-col items-center justify-between gap-[50px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Fuel Cost Calculator | Calculators | BoloSign"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "BoloSign helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "geo.region",
                        content: "IN"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "geo.position",
                        content: "22.351115;78.667743"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "ICBM",
                        content: "22.351115, 78.667743"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "author",
                        content: "BoloSign"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "publisher",
                        content: "BoloSign "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/calculators/fuel-cost-calculator/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: "https://www.bolosign.com/calculators/fuel-cost-calculator/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: "Fuel Cost Calculator | Calculators | BoloSign"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: "BoloSign helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:domain",
                        content: "https://bolosign.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:url",
                        content: "https://www.bolosign.com/calculators/fuel-cost-calculator/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: "BoloSign helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: "BoloSign helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-0 z-[-500] left-0 w-full bg-violet-500 h-[500px]"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-[15px] sm:gap-[30px] w-full xl:w-[80%] text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "font-bold text-[45px] xl:text-[60px] leading-[45px] xl:leading-[60px] text-white",
                        children: "Fuel Cost Calculator"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-white text-[16px] lg:text-[18px] font-light",
                        children: "Take control of your fuel expenses with our free Fuel Cost Calculator tool. Calculate the total cost of fuel required for your trip based on fuel prices and distance traveled. Our Fuel Cost Calculator also provides the cost per gallon/litre of fuel, the total fuel volume, and the total cost of fuel based on your inputs. Whether you're planning a road trip or simply want to keep track of your fuel expenses, our Fuel Cost Calculator is the perfect tool."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tools_FuelCostCalc, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Blog/* default */.Z, {
                heading: "Fuel Cost Calculator FAQs",
                BlogData: BlogData
            })
        ]
    });
};
/* harmony default export */ var fuel_cost_calculator = (FuelCostCalculator);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4617,9774,2888,179], function() { return __webpack_exec__(96201); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);